import {useMemo} from 'react';

import type {RunHistoryKeyType} from '../../../../types/run';
import {useNumPanelsByKey} from './useNumPanelsByKey';
import {useSearchedKeys, useSearchedKeysPaginated} from './useSearchedKeys';

export const useQuickAddKeys = (
  searchStr = '',
  keyType?: RunHistoryKeyType
) => {
  const searchedKeys = useSearchedKeys(searchStr, keyType);
  const numPanelsByKey = useNumPanelsByKey();
  const keysWithNoPanels = useMemo(
    () => searchedKeys.filter(([key]) => !numPanelsByKey.global.get(key)),
    [searchedKeys, numPanelsByKey]
  );
  return {
    searchedKeys,
    numPanelsByKey,
    keysWithNoPanels,
  };
};

export const useQuickAddKeysPaginated = (
  searchStr = '',
  cursor: string | null = null,
  pageSize = 100
) => {
  const numPanelsByKey = useNumPanelsByKey();
  const searchedKeys = useSearchedKeysPaginated(searchStr, cursor, pageSize);

  const keysWithNoPanels = useMemo(() => {
    return searchedKeys.keys.filter(([key]) => !numPanelsByKey.global.get(key));
  }, [searchedKeys, numPanelsByKey]);

  return {
    searchedKeys,
    numPanelsByKey,
    keysWithNoPanels,
  };
};
